import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Location } from '@angular/common';

@Injectable()
export class CanActivateViaPermissionService implements CanActivate {

  constructor(
    private _auth: AuthService,
    private _location: Location,
    private router: Router
  ) {}

  canActivate() {
    if(this._auth.hasPermissions('manager')) {
      return true;
    } else {
      this._location.back();
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/services/can-activate-via-permission.service.ts